import { render } from "./IconMenuBarcodeImport.vue?vue&type=template&id=c26691de"
import script from "./IconMenuBarcodeImport.vue?vue&type=script&lang=ts"
export * from "./IconMenuBarcodeImport.vue?vue&type=script&lang=ts"
script.render = render

export default script